import React from "react";

const UnauthorizedAccessLayout = () => {
  return <div>UnauthorizedAccessLayout</div>;
};

export default UnauthorizedAccessLayout;
